"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onClickCursor = exports.styleByCase = exports.ifNotDisabled = exports.always = exports.stateHoverActive = exports.stateHoverActiveCustom = void 0;

var tslib_1 = require("tslib");

var styled_components_1 = require("styled-components");

exports.stateHoverActiveCustom = function (property, _a) {
  var color = _a.color,
      hoverColor = _a.hoverColor,
      activeColor = _a.activeColor;
  return styled_components_1.css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n\t\t", ": ", ";\n\t\t@media (hover: hover) {\n\t\t\t&:hover {\n\t\t\t\t", ": ", ";\n\t\t\t}\n\t\t}\n\t\t&:active {\n\t\t\t", ": ", ";\n\t\t}\n\t"], ["\n\t\t", ": ", ";\n\t\t@media (hover: hover) {\n\t\t\t&:hover {\n\t\t\t\t", ": ", ";\n\t\t\t}\n\t\t}\n\t\t&:active {\n\t\t\t", ": ", ";\n\t\t}\n\t"])), property, color, property, hoverColor, property, activeColor);
};

exports.stateHoverActive = function (property, palette) {
  return exports.stateHoverActiveCustom(property, {
    color: palette[500],
    hoverColor: palette[700],
    activeColor: palette[900]
  });
};

exports.always = function (property, value) {
  return styled_components_1.css(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n\t\t", ": ", ";\n\t\t&:hover,\n\t\t&:active {\n\t\t\t", ": ", ";\n\t\t}\n\t"], ["\n\t\t", ": ", ";\n\t\t&:hover,\n\t\t&:active {\n\t\t\t", ": ", ";\n\t\t}\n\t"])), property, value, property, value);
};

exports.ifNotDisabled = function (value) {
  return function (props) {
    return !props.disabled && value;
  };
};

exports.styleByCase = function (activeStyle, disabledStyle) {
  return styled_components_1.css(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n\t\t", ";\n\t\t&:disabled {\n\t\t\t", ";\n\t\t}\n\t"], ["\n\t\t", ";\n\t\t&:disabled {\n\t\t\t", ";\n\t\t}\n\t"])), exports.ifNotDisabled(activeStyle), disabledStyle);
};

exports.onClickCursor = styled_components_1.css(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n\t", ";\n"], ["\n\t", ";\n"])), function (_a) {
  var onClick = _a.onClick;
  return onClick && styled_components_1.css(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n\t\t\tcursor: pointer;\n\t\t"], ["\n\t\t\tcursor: pointer;\n\t\t"])));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;